import { mainApiInstance } from "../_axiosInstance";

export interface MembershipUsageResponse {
  id: string;
  status: string;
  type: string;
  expired_at: string;
  pay_at: string;
  created_at: string;
  scheduled_change: string | null;
  usage: Record<string, string>;
  product_rate: {
    rate: string;
    amount: string;
    priceId: string;
    billingCycle: string;
  };
}

const getUsage = async () => {
  try {
    const response =
      await mainApiInstance.get<MembershipUsageResponse>("/membership/usage");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const usageService = {
  getUsage,
};
